const initialState = {
  isUserLocation: false,
};

export default initialState;
